const report = {
  path: 'report',
  component: resolve => require(['../../../../components/pages/signUp/report'], resolve)
}
export default report



// WEBPACK FOOTER //
// ./src/router/pages/signUp/report/index.js